// Import React and necessary components from Shadcn UI or your specific UI library
import React from "react";
import { Card, CardHeader, CardContent, CardFooter } from "./ui/card";

interface DirectDebitGuaranteeProps {
  data: any;
}

const DirectDebitGuarantee: React.FC<DirectDebitGuaranteeProps> = ({
  data,
}) => {
  return (
    <Card className="text-left w-full max-w-3xl">
      <CardHeader>
        <div className="flex flex-row justify-between items-center">
          <h1 className="text-2xl mb-2">Direct Debit Guarantee</h1>
          <img
            className="w-36"
            src="https://yavrio-public.s3.eu-west-2.amazonaws.com/assets/images/bacs-dd-logo.jpg"
            alt=""
          />
        </div>
      </CardHeader>
      <CardContent>
        <div className="grid grid-cols-2 gap-10 text-sm text-gray-500">
          <ul className="flex flex-col gap-4 list-disc list-inside">
            <li>
              This Guarantee is offered by all banks and building societies that
              accept instructions to pay Direct Debits.
            </li>
            <li>
              If there are any changes to the amount, date or frequency of your
              Direct Debit, {data.originatorCompanyName} will notify you 3
              working days in advance of your account being debited or as
              otherwise agreed. If you request {data.originatorCompanyName} to
              collect a payment, confirmation of the amount and date will be
              given to you at the time of the request.
            </li>
          </ul>

          <ul className="flex flex-col gap-4 list-disc list-inside">
            <li>
              If an error is made in the payment of your Direct Debit, by{" "}
              {data.originatorCompanyName} or your bank or building society, you
              are entitled to a full and immediate refund of the amount paid
              from your bank or building society – If you receive a refund you
              are not entitled to, you must pay it back when{" "}
              {data.originatorCompanyName} asks you to.
            </li>
            <li>
              You can cancel a Direct Debit at any time by simply contacting
              your bank or building society. Written confirmation may be
              required. Please also notify us.
            </li>
          </ul>
        </div>
      </CardContent>
      <CardFooter></CardFooter>
    </Card>
  );
};

export default DirectDebitGuarantee;
